import React from "react";
import { UserGameplayOutcome } from "@nestcoinco/hyper-api-gateway-api-client";

import "./StreakItem.scss";

export default function StreakItem({ result }: { result?: string }) {
  let bgClass: string;
  if (result === UserGameplayOutcome.W) bgClass = "win";
  else if (result === UserGameplayOutcome.L) bgClass = "loss";
  else if (result === UserGameplayOutcome.T) bgClass = "tie";
  else bgClass = "blank";

  return (
    <div className={`streak-item ${bgClass}`}>
      <span>{result === UserGameplayOutcome.T ? "D" : result}</span>
    </div>
  );
}
